/* eslint-disable camelcase */
const applicationModalController = (
  $scope,
  $modal,
  logger,
  ApplicationModalApi,
  $rootScope
) => {
  let modalInstance

  if ($scope.position.isApplied)
    $scope.position.tooltip = 'Already applied to position'
  else if ($scope.candidate.resumes.length === 0)
    $scope.position.tooltip = 'Upload your CV to apply.'
  else if ($scope.candidate.approvalStatus === 'Locked')
    $scope.position.tooltip =
      'Your profile is locked, wait for reapproval to apply for jobs'
  else $scope.position.tooltip = undefined

  $scope.shareProfile = (position, event) => {
    const resumes = $scope.candidate.resumes

    console.debug('resumes:', resumes)

    const sortedResumes =
      resumes &&
      resumes.length > 0 &&
      resumes.filter(Boolean).sort((a, b) => {
        console.debug('sortedResumes', {a, b})
        const x = Date.parse(a.created)
        const y = Date.parse(b.created)
        console.debug('sortedResumes', {x, y})

        const tx = x && x.getTime && x.getTime()
        const ty = y && y.getTime && y.getTime()

        if (tx < ty) {
          return -1
        }

        if (tx > ty) {
          return 1
        }

        return 0
      })

    const mostRecentResume =
      sortedResumes && sortedResumes.length > 0
        ? sortedResumes[sortedResumes.length - 1]
        : undefined

    const modalData = {
      position: $scope.position,
      candidate: _.extend($scope.candidate, {resumes: sortedResumes}),
      sponsorship: false,
      resume: mostRecentResume && mostRecentResume.id,
    }
    console.debug(
      'applicationModalController::shareProfile:modalData',
      modalData
    )
    $scope.modalData = modalData

    $scope.locationBackgroundColor = color => {
      if (color) {
        return {
          background: color,
        }
      }
    }

    event.preventDefault()
    event.stopPropagation()

    modalInstance = $modal.open({
      backdrop: 'static',
      templateUrl: 'application-modal.html',
      scope: $scope,
      resolve: {
        data: function() {
          return $scope.modalData
        },
      },
    })

    modalInstance.result.then(
      _selectedItem => {
        $scope.position.isApplied = true
        $scope.position.appliedOffPlatform = true
        $scope.position.applicationDate = new Date()
      },
      () => {}
    )
  }

  $scope.applyForApplication = async () => {
    const application = {
      user: $scope.candidate.id,
      position: $scope.position.id,
      resume: $scope.modalData.resume,
      isOffPlatform: !$scope.client,
      sponsorship: $scope.modalData.sponsorship,
    }

    try {
      analytics.track('job - share profile', {
        job_company: $scope.position.employer.name,
        user_id: $scope.candidate.id,
        job_id: $scope.position.id,
        job_title: $scope.position.title,
        currentEmployerName: $scope.candidate.employer.name,
        currentEmployerId: $scope.candidate.employer.id,
        current_emp: $scope.candidate.employer.name,
        name: `${$scope.candidate.firstName} ${$scope.candidate.lastName}`,
      })
    } catch (error) {
      console.error('analytics: job - share profile error', error)
    }

    await ApplicationModalApi.createApplication(application).then(() => {
      if ($scope.client)
        logger.notify(
          'success',
          'Thank you for your application. You can track the status of your applications on the Track page'
        )
    })

    console.debug('broadcasting application:created')
    $rootScope.$broadcast('application:created')

    modalInstance.close(application)
  }

  $scope.cancel = () => {
    modalInstance.dismiss('cancel')
  }
}

export {applicationModalController}



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-modal/application-modal.ctrl.js